var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c7c7c5",
    height: 328,
    rx: 24,
    width: 368,
    x: 120,
    y: 120
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#cfcfcd",
    height: 328,
    rx: 24,
    width: 368,
    x: 120,
    y: 88
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d6d6d4",
    height: 328,
    rx: 24,
    width: 368,
    x: 120,
    y: 56
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 384h-264a24 24 0 0 1 -24-24v-280a24 24 0 0 1 24-24h320a24 24 0 0 1 24 24v224z",
    fill: "#e0e0de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 56h320a24 24 0 0 1 24 24v64a0 0 0 0 1 0 0h-368a0 0 0 0 1 0 0v-64a24 24 0 0 1 24-24z",
    fill: "#348fd9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 384v-56a24 24 0 0 1 24-24h56z",
    fill: "#ebebe9"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d6d6d4",
    height: 64,
    rx: 16,
    width: 32,
    x: 168,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d6d6d4",
    height: 64,
    rx: 16,
    width: 32,
    x: 248,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d6d6d4",
    height: 64,
    rx: 16,
    width: 32,
    x: 328,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d6d6d4",
    height: 64,
    rx: 16,
    width: 32,
    x: 408,
    y: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 280-45.592 9.1a119.619 119.619 0 1 0 20.515 33.057z",
    fill: "#348fd9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 344h-48v-48h-48v48h-48v48h48v48h48v-48h48z",
    fill: "#ebebe9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#17588f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232 184h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 184h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 184h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424 184h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 184h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 248h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 248h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424 248h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 248h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 312h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 312h16v16h-16z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/appointment-icon.92e5fd5c7655ed1fd3a8239a4e7286e1.svg";
export { ForwardRef as ReactComponent };